// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__HBge2","header":"ClearentDisclaimer_header__DsBTI","inner":"ClearentDisclaimer_inner__2WyMd"};